module.exports = __webpack_public_path__ + "media/images/kuwait-image2-d705d7a424d04580561bcfa5fb757f36.jpg";